import { RouteComponentProps } from 'react-router-dom';

import { updateURLSearchParams } from '.';

/**
 * Given a `history` object and a list of URL parameters to update, apply the updates and replace
 * the current history location with a location that includes the updated search params.
 * @param history - the react-router `history` object returned by its useHistory hook
 * @param paramUpdates - an array of {@link URLSearchParam} objects
 */
export const updateAndReplaceURLSearchParams = (
    history: RouteComponentProps['history'],
    paramUpdates: URLSearchParam[],
): void => {
    const updatedSearch = updateURLSearchParams(
        history.location.search,
        paramUpdates,
    );

    history.replace({
        search: `?${updatedSearch}`,
        pathname: history.location.pathname,
        hash: history.location.hash,
    });
};
